var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('hos_apply_title',{attrs:{"title":_vm.state == 'REFUSED' ? '拒绝原因' : '取消原因'}}),_c('div',{staticClass:"mt20 content"},[_vm._t("cancle_content")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }